import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { UserProfileViewTopBar } from "./TopBar"

export const userProfileViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: UserProfileViewTopBar,
}
